import { useEffect } from 'react';
import {useDispatch} from 'react-redux';
import {IntlProvider} from 'react-intl';
import { Layout } from 'antd';

import HeaderComponent from "./Header";
import ContentComponent from "./Content";
import "../../styles/layout.css";
import { useKeycloak } from '@react-keycloak/web';
import {fetchUserProfile} from '../../actions/userAction';


import {getLanguage} from '../../utils/internationalization';
import { IUserProfile } from '../../types/userTypes';

const LayoutComponent = ()=> {
  const {initialized,keycloak}=useKeycloak();
  const locale = getLanguage();
  const dispatch=useDispatch();


  useEffect(()=>{
    if(initialized)
    keycloak.loadUserProfile().then((resp: IUserProfile) => dispatch(fetchUserProfile(resp)));
  },[dispatch,initialized,keycloak]);

    return (
      <IntlProvider messages={locale.message} locale={locale.locale}>
        <Layout>
            <HeaderComponent/>
            <ContentComponent />
          </Layout>
      </IntlProvider>
    );
}
export default LayoutComponent;